import { createContext, useContext } from "react";

export type StepUpAuthContextValue = {
  runProtectedAction: <T>(action: () => Promise<T>) => Promise<T>;
};

export const StepUpAuthContext = createContext<StepUpAuthContextValue | null>(null);

async function passthroughProtectedAction<T>(action: () => Promise<T>): Promise<T> {
  return action();
}

export const useStepUpProtectedAction = (): StepUpAuthContextValue => {
  const context = useContext(StepUpAuthContext);
  if (!context) {
    return {
      runProtectedAction: passthroughProtectedAction,
    };
  }

  return context;
};
